export default {
  apiServer: `${location.protocol}//${location.host}/api`,
}
